import { usePermissions } from '@/composables/usePermissions';

export default {
    mounted(el, binding, vnode) {
        // Access the Vuex store via the component instance
        console.log("vnode", vnode)
        // const store = vnode.context?.$store;
        const store = vnode.ctx.appContext.config.globalProperties.$store
        // console.log("store state data in permission directive", store._state.data)
        // console.log("userPermissions in permission directive from store", store._state.data.userPermissions)


        if (!store) {
            console.error('Vuex store is not available in the directive context.');
            return;
        }

        const { userPermissions } = store._state.data;

        // if (!userPermissions.includes(binding.value)){
        //     el.style.display = 'none'; // Hide element if permission is missing
        // }

        // const hasPermission = (permission) => {
        //     return userPermissions.value.includes(permission);
        // };

        // if (!hasPermission(binding.value)) {
        //     el.style.display = 'none'; // Hide element if permission is missing
        // }
    },
};


// ==================updated------------------------=======
// export default {
//   async  mounted(el, binding, vnode) {
//         const store = vnode.ctx?.appContext?.config?.globalProperties?.$store;

//         if (!store) {
//             console.error('Vuex store is not available in the directive context.');
//             return;
//         }

//         const user = await store._state?.data?.user;
//         const permissions = await user?.userPermissions;

//         // Check if permissions is a valid array
//         if (!Array.isArray(permissions)) {
//             console.warn('userPermissions is not an array:', permissions);
//             el.style.display = 'none'; // Or choose to do nothing
//             return;
//         }

//         if (!permissions.includes(binding.value)) {
//             el.style.display = 'none';
//         }
//     }
// };
